import React, { useEffect, useState } from 'react';

import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import classes from './CompanySelect.module.css';

const CompanySelect = ({
    companies,
    companyInfo,
    companySelect,
    clearErrors,
    ...props
}) => {

    const [ sortedCompanies, setSortedCompanies ] = useState();
    const [ companyId, setCompanyId ] = useState();

    useEffect(() => {
        if (companies && companies.length) {
            setSortedCompanies(companies.sort((a, b) => {
                return (a.company.name.toUpperCase() > b.company.name.toUpperCase()) ? 1 : -1;
            }));
        }
    }, [companies]);

    useEffect(() => {
        if (companyInfo) {
            setCompanyId(companyInfo.companyId);
        }
    }, [companyInfo]);

    const handleCompanySelect = event => {
        const { value } = event.target;

        if (value === companyId) {
            return;
        }

        clearErrors();
        companySelect(value);
        setCompanyId(value);
    };

    return (
        <div className={classes.CompanySelect}>
            <FormControl className={classes.setWidth}>
                {companyId &&
                <Select
                    value={companyId}
                    onChange={handleCompanySelect}
                    className={classes.select}
                    inputProps={{
                        name: 'company',
                        id:   'company'
                    }}
                >
                    {sortedCompanies.map(company => {
                        return (
                            <MenuItem
                                key={company.company.id}
                                className={company.company.id === companyId
                                    ? `${classes.basicMenuItem} ${classes.selected}` : `${classes.basicMenuItem}`}
                                value={company.company.id}
                            >
                                <span>{company.company.name}</span>
                            </MenuItem>
                        );
                    })}
                </Select>
                }
            </FormControl>
        </div>
    );
};

export default CompanySelect;
